<template>
  <p class="text-primary">
    {{ addressStreet }}
    {{ addressBuildingNumber }} <template v-if="addressHouseNumber"> / {{ addressHouseNumber }}</template>,
    {{ addressPostCode }}, {{ addressCity }}<br>
    <small>
      {{ addressName }} {{ addressSurname }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'order-info-address',
  props: [
    'addressName',
    'addressSurname',
    'addressStreet',
    'addressBuildingNumber',
    'addressHouseNumber',
    'addressPostCode',
    'addressCity'
  ]
}
</script>
